import { createRef, useEffect, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { SUCCESS, WARNING, ERROR, expireNotification } from 'common/state/notificationState';
import zIndices from 'common/utils/zIndices';
import { useSelectorTyped } from 'common/store/useSelectorTyped';

interface NotificationProps {
  id?: number;
  msg?: string;
  type?: string;
}

const Notification = forwardRef<HTMLDivElement, NotificationProps>(
  ({ id = 0, msg = '', type = '' }, ref) => {
    const dispatch = useDispatch();
    useEffect(() => {
      setTimeout(() => {
        dispatch(expireNotification(id));
      }, 2000);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const { className, icon } = {
      [SUCCESS]: {
        icon: 'fa-check',
        className: 'success',
      },
      [WARNING]: {
        icon: 'fa-exclamation-triangle',
        className: 'warning',
      },
      [ERROR]: {
        icon: 'fa-exclamation-circle',
        className: 'error',
      },
    }[type];
    return (
      <div ref={ref} className="notification" style={{ zIndex: zIndices.notificationDisplay }}>
        <div className={`icon ${className}`}>
          <i className={`fa ${icon}`} />
        </div>
        <div className="msg">{msg}</div>
      </div>
    );
  }
);

export default function Notifications() {
  const notifications = useSelectorTyped(state => state.notificationState.notifications);
  const notificationsWithRef = Object.entries(notifications).map(([id, notification]) => [
    id,
    {
      ...notification,
      nodeRef: createRef(null),
    },
  ]);
  return (
    <TransitionGroup component={null}>
      {notificationsWithRef.map(([id, notification]) => (
        <CSSTransition
          timeout={150}
          key={id}
          classNames="notification"
          nodeRef={notification.nodeRef}
        >
          <Notification
            msg={notification.msg}
            id={id}
            ref={notification.nodeRef}
            type={notification.type}
          />
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
}
